
export default function Img({ src, width = "20px" }) {
  return <img src={src} width={width} />;
}
